import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Modal,
  Tab,
  Tabs,
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useEffect, useLayoutEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bookingOptions } from '../../../../../../constants/HotelServicesConst';
import CustomActiveInactiveRadio from '../../../../../../shared/form-controls/custom-active-inactive-radio/Custom-Active-Inactive-Radio';
import CustomSelect from '../../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';
import { formDataValidate } from '../../../../../../utils/formUtils';
import { createOrUpdateRestaurantReservation } from '../../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import {
  fetchRestaurantConfigs,
  fetchRestaurantList,
  restaurantConfigsSelector,
  restaurantSelector,
} from '../../../../configurationSlice';
import './Restaurant-reservation.scss';
import { decryptLocalStorage } from '../../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../env/Configurations';

const RestaurantReservation = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const restaurants = useSelector(restaurantSelector);
  const restaurantConfigList = useSelector(restaurantConfigsSelector);
  const configuredRestaurants =
    restaurantConfigList.length > 0 &&
    restaurantConfigList.filter((restaurant) => restaurant.posActive);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    dispatch(fetchRestaurantList(selectedHotel));
    dispatch(fetchRestaurantConfigs(selectedHotel));
  }, [restaurants]);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '52%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: 700,
    bgcolor: 'white',
    borderRadius: '20px',
    border: 'none',
    p: 4,
    outline: 'none',
    overflow: 'auto',
  };

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    restaurantSelected: {
      value: '',
      fieldName: 'Select Restaurant',
      errors: {},
      validations: ['required'],
    },
    integrationSource: {
      value: '',
      fieldName: 'Integration Source',
      errors: {},
      validations: [],
    },
    integrationSourceSelected: {
      value: '',
      fieldName: '',
      errors: {},
      validations: [],
    },
    hostingType: {
      value: false,
      fieldName: 'On-Prem Hosting',
      errors: {},
      validations: [],
    },
  });

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const refactorPayload = () => {
    if (validate()) {
      return {
        hotelId: selectedHotel,
        restaurantId: formData?.restaurantSelected?.value,
      };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const language = lang !== 'en' ? lang : '';

      createOrUpdateRestaurantReservation(refactorPayload(), language).then(() => {
        notificationManager('success', 'Restaurant details updated successfully');
        dispatch(fetchRestaurantList(selectedHotel));
        dispatch(fetchRestaurantConfigs(selectedHotel));
      });
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }
      notificationManager('danger', 'Unable to update restaurant details');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const getName = (item) => {
    const nameArr = restaurants.filter((restaurant) => {
      return restaurant.id === item.restaurantId;
    });
    return nameArr[0]?.name ?? '';
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className='restaurant-reservation' noValidate>
        <div className='col-12 hotel-service-tab-section'>
          <div className='col col-xl-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Integration Settings' />
              <Tab label='Configurable features' />
            </Tabs>
          </div>
        </div>

        {tabValue === 0 && (
          <div className='mx-4'>
            <IntegrationSource
              formData={formData}
              setFormData={setFormData}
              section='Restaurant Reservation'
              headTitle='Integration Source'
              showLoader={showLoader}
            />
          </div>
        )}

        {tabValue === 1 && (
          <div className='mx-4 mt-2'>
            <div className='row align-items-end'>
              <div className='col-md-9'>
                <CustomSelect
                  item={formData.restaurantSelected}
                  handleInputChange={(e) => {
                    setFormData({ restaurantSelected: e });
                  }}
                  hideNullOption={true}
                  options={
                    restaurants && restaurants.length > 0
                      ? restaurants.map((restaurant) => {
                          return { id: restaurant.id, name: restaurant.name };
                        })
                      : [{}]
                  }
                  className='res-select'
                />
              </div>
              <div className='col-auto col-md-auto pointer' onClick={() => handleOpen()}>
                <u>
                  {configuredRestaurants.length}/{restaurantConfigList.length} Restaurants
                  Configured
                </u>
              </div>
            </div>
            <div>
              <div className='hotel-service-section'>
                <div className='row mt-auto px-4 w-100 pb-5'>
                  <div className='col-md-12 mt-3 d-flex justify-content-start'>
                    <Button variant='contained' type='submit' color='primary' size='large'>
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <div className='container restaurant-modal'>
            <div className=' d-flex align-items-center flex-column'>
              <div className='row w-100 mt-1 align-items-center justify-content-between'>
                <div className='col-md-8'>
                  <span className='header-title'>Restaurant Configuration Status</span>
                </div>
                <div className='col-md-1 d-flex justify-content-end'>
                  <IconButton onClick={(e) => handleClose()}>
                    <CancelIcon />
                  </IconButton>
                </div>
              </div>
            </div>
            <div className='row d-flex align-items-center mt-4 header-row ms-2'>
              <div className='col-4 ms-3 table-header-item'>Restaurant name</div>
              <div className='col-4 table-header-item'>Configuration status</div>
            </div>
            {restaurantConfigList &&
              restaurantConfigList.length > 0 &&
              restaurantConfigList.map((item, i) => (
                <div key={i}>
                  <div className='row d-flex align-items-center mt-1 table-row ms-2 py-3'>
                    <div className='col-4 ms-3 table-item'>
                      {restaurants && restaurants.length > 0 ? String(getName(item)) : ''}
                    </div>
                    <div className='col-4 table-item'>
                      <div className='d-flex ms-3 align-content-center w-25'>
                        <div
                          className={`${item.posActive ? 'pill-active ' : 'pill-inactive '} 
                          pill d-flex justify-content-center align-items-center`}
                        >
                          <span className='ms-1'>{item.posActive ? 'Completed' : 'Pending'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default RestaurantReservation;
